import { FuseNavigation } from "@fuse/types";

export const navigation: FuseNavigation[] = [
  {
    id: "applications",
    title: "",
    translate: "",
    type: "group",
    children: [
      {
        id: "sample",
        title: "Profile",
        translate: "",
        type: "item",
        icon: "person",
        url: "/user/member_view/self",
      },
      {
        id: "images",
        title: "Desings",
        translate: "",
        type: "item",
        icon: "image",
        url: "/other/vadivagal",
      },
      {
        id: "forms",
        title: "Forms",
        translate: "",
        type: "item",
        icon: "assignment",
        url: "/other/padivagal",
      },
      {
        id: "logos",
        title: "Logos",
        translate: "",
        type: "item",
        icon: "sentiment_satisfied_alt",
        url: "/other/lachanagal",
      },
      {
        id: "case studies",
        title: "Case Studies",
        translate: "",
        type: "item",
        icon: "assessment",
        url: "/other/valaku_avanagal",
      },
      // {
      //     id       : 'calendar',
      //     title    : 'Events',
      //     translate: '',
      //     type     : 'item',
      //     icon     : 'today',
      //     url      : '/events'
      // },
    ],
  },
  // {
  //     id      : 'documentation',
  //     title   : 'Documentation',
  //     icon    : 'import_contacts',
  //     type    : 'group',
  //     children: [
  //         {
  //             id   : 'changelog',
  //             title: 'Changelog',
  //             type : 'item',
  //             icon : 'update',
  //             url  : '/documentation/changelog',
  //             badge: {
  //                 title: '9.0.0',
  //                 bg   : '#EC0C8E',
  //                 fg   : '#FFFFFF'
  //             }
  //         },
  //         {
  //             id      : 'getting-started',
  //             title   : 'Getting Started',
  //             type    : 'collapsable',
  //             icon    : 'import_contacts',
  //             children: [
  //                 {
  //                     id   : 'introduction',
  //                     title: 'Introduction',
  //                     type : 'item',
  //                     url  : '/documentation/getting-started/introduction'
  //                 },
  //                 {
  //                     id   : 'installation',
  //                     title: 'Installation',
  //                     type : 'item',
  //                     url  : '/documentation/getting-started/installation'
  //                 }
  //             ]
  //         },
  //     ]
  // }
];
